import type { LogoDePrixia } from './elegir-logo';

/** Lo que dura la apertura en el prototipo 04. */
export const DURACION_APERTURA: Record<LogoDePrixia, number> = { clasico: 4100, nuevo: 4300 };
/** Si el 3D tarda más que esto en bajar, se va al estado final. */
export const PLAZO_DE_CARGA_MS = 1500;
/** Si la escena no termina en su duración más esto, también. */
export const MARGEN_DE_SEGURIDAD_MS = 1000;

export interface EstadoDeApertura {
  marca: boolean;
  tarjetas: readonly [boolean, boolean, boolean];
  titulo: boolean;
  cta: boolean;
  terminada: boolean;
}

export const APERTURA_INICIAL: EstadoDeApertura = {
  marca: false,
  tarjetas: [false, false, false],
  titulo: false,
  cta: false,
  terminada: false,
};

export const APERTURA_FINAL: EstadoDeApertura = {
  marca: false,
  tarjetas: [true, true, true],
  titulo: true,
  cta: true,
  terminada: true,
};

/** Lo que se ve en el milisegundo `t`: la única cuenta de tiempos de la apertura. */
export function estadoDeApertura(t: number, logo: LogoDePrixia): EstadoDeApertura {
  return {
    marca: t > 950 && t < 2050,
    tarjetas: [t > 3120, t > 3250, t > 3380],
    titulo: t > 3300,
    cta: t > 3700,
    terminada: t >= DURACION_APERTURA[logo],
  };
}

export const mismoEstado = (a: EstadoDeApertura, b: EstadoDeApertura) =>
  a.marca === b.marca &&
  a.titulo === b.titulo &&
  a.cta === b.cta &&
  a.terminada === b.terminada &&
  a.tarjetas.every((v, i) => v === b.tarjetas[i]);
